import { render, staticRenderFns } from "./orderLoanStatusLoanCount.vue?vue&type=template&id=0022d9fc&scoped=true&"
import script from "./orderLoanStatusLoanCount.vue?vue&type=script&lang=js&"
export * from "./orderLoanStatusLoanCount.vue?vue&type=script&lang=js&"
import style0 from "./orderLoanStatusLoanCount.vue?vue&type=style&index=0&id=0022d9fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022d9fc",
  null
  
)

export default component.exports